// Fire-and-forget: log a completed email analysis to the reporting backend.
// Never throws — must never block or crash the analysis UI.
export function logAnalysis(payload) {
  try {
    const token =
      sessionStorage.getItem("auth_token") ||
      sessionStorage.getItem("auth_token");
    const rawUser =
      localStorage.getItem("auth_user") ||
      sessionStorage.getItem("auth_user");
    const user = rawUser ? JSON.parse(rawUser) : null;

    const body = {
      ...payload,
      analyst_id: user?.userId ?? user?.id ?? null,
      analyst_username: user?.name ?? user?.username ?? null,
      analyst_email: user?.email ?? null,
    };

    console.log("[logAnalysis] firing POST /api/reports/log", body);

    fetch("/api/reports/log", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    })
      .then((r) => {
        if (r.ok) {
          r.json().then((j) => console.log("[logAnalysis] logged OK:", j));
        } else {
          r.text().then((t) => console.warn("[logAnalysis] server error:", r.status, t));
        }
      })
      .catch((err) => console.warn("[logAnalysis] fetch failed:", err.message));
  } catch (err) {
    console.warn("[logAnalysis] unexpected error:", err.message);
  }
}
